<template>
  <div>
    <el-container>
      <el-header>
        <el-button-group>
          <el-button v-if="simulator.meta.state === simulator.STATE.PAUSE"
                     type="primary" icon="fa fa-fw fa-play" title="推演" @click.stop="play"/>
          <el-button v-else
                     type="primary" icon="fa fa-fw fa-pause" title="暂停" @click.stop="pause"/>
          <el-button type="default" icon="fa fa-fw fa-forward" title="快进" :style="forward ? 'color: red': ''"
                     @click.stop="forward = !forward"/>
          <el-button :disabled="simulator.meta.state !== simulator.STATE.PAUSE"
                     type="default" icon="fa fa-fw fa-step-forward" title="步进" @click.stop="tick"/>
          <el-button type="default" icon="fa fa-fw fa-undo" title="重置" @click.stop="reset"/>
          <el-button disabled type="default" icon="fa fa-fw fa-save" title="方案"/>
          <el-button disabled type="default" icon="fa fa-fw fa-book" title="资料"/>
        </el-button-group>
        &nbsp;
        <el-radio-group v-model="automate">
          <el-radio-button :label="false">手动</el-radio-button>
          <el-radio-button :label="true">自动</el-radio-button>
        </el-radio-group>
        &nbsp;
        <el-input readonly v-model="simulator.meta.elapse" style="width: auto;vertical-align: middle">
          <template slot="prepend">时间</template>
        </el-input>
        <el-divider/>
      </el-header>
      <el-container>
        <el-aside width="720px">
          <el-form>
            <el-form-item label="应急资源">
              <el-table :data="simulator.station.engine.types">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      :data="typedEngines(props.row.type)">
                      <el-table-column label="编号" prop="name"/>
                      <el-table-column label="状态">
                        <template slot-scope="scope">
                          {{simulator.station.engine.stateNames[scope.row.state]}}
                        </template>
                      </el-table-column>
                      <el-table-column label="目标" prop="cruise.dst"/>
                      <el-table-column label="行程">
                        <template slot-scope="scope">
                          {{cruiseProgress(scope.row)}}%
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.type"/>
                  </template>
                </el-table-column>
                <el-table-column label="流量（L/s）">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.flow" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'flow', 1, 10, 60)"/>
                  </template>
                </el-table-column>
                <el-table-column label="储量（L）">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.capacity" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'capacity', 50, 5000, 30000)"/>
                  </template>
                </el-table-column>
                <el-table-column label="速度（km/s）">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.speed" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'speed', 5, 10, 120)"/>
                  </template>
                </el-table-column>
                <el-table-column label="准备时间（分）">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.prepare" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'prepare', 1, 1, 30)"/>
                  </template>
                </el-table-column>
                <el-table-column label="可用数量">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.amount" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'amount', 1, 5, 50)"/>
                  </template>
                </el-table-column>
                <el-table-column width="160px">
                  <template slot-scope="scope">
                    <el-button icon="fa fa-fw fa-plus" type="success"
                               :disabled="!prepare"
                               @click.stop="simulator.station.engine.copyType(scope.row.type)"/>
                    <el-button icon="fa fa-fw fa-minus" type="danger"
                               :disabled="!prepare || simulator.station.engine.types.length < 2"
                               @click.stop="simulator.station.engine.dropType(scope.row.type)"/>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label="承灾载体">
              <el-table :data="simulator.airport.aircraft.types">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table
                      :data="typedAircrafts(props.row.type)">
                      <el-table-column label="编号">
                        <template slot-scope="scope">
                          {{scope.row.name}}
                        </template>
                      </el-table-column>
                      <el-table-column label="耐久">
                        <template slot-scope="scope">
                          {{scope.row.durability}}
                        </template>
                      </el-table-column>
                      <el-table-column label="位置" width="240px">
                        <template slot-scope="scope">
                          <el-input v-model.number="simulator.map.get(scope.row.name)['x']" style="width: 100px"
                                    @mousewheel.native="wheelChange($event, simulator.map.get(scope.row.name), 'x', 5, 200, 1000)">
                            <template slot="prepend">x:</template>
                          </el-input>
                          &nbsp;
                          <el-input v-model.number="simulator.map.get(scope.row.name)['y']" style="width: 100px"
                                    @mousewheel.native="wheelChange($event, simulator.map.get(scope.row.name), 'y', 5, 200, 1000)">
                            <template slot="prepend">y:</template>
                          </el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="资源">
                        <template>
                          &nbsp;
                        </template>
                      </el-table-column>
                      <el-table-column width="160px"/>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.type" :readonly="!prepare"
                              @input="(val) => aircraftTypeUpdate(scope.row.typeId, 'type', val)"/>
                  </template>
                </el-table-column>
                <el-table-column label="耐久">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.durability" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'durability', 100, 200000, 1000000, 'aircraftType')"
                              @input="(val) => aircraftTypeUpdate(scope.row.typeId, 'durability', val)"/>
                  </template>
                </el-table-column>
                <el-table-column label="数量">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.amount" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'amount', 1, 1, 10, 'aircraftType')"
                              @input="(val) => aircraftTypeUpdate(scope.row.typeId, 'amount', val)"/>
                  </template>
                </el-table-column>
                <el-table-column width="160px">
                  <template slot-scope="scope">
                    <el-button icon="fa fa-fw fa-plus" type="success"
                               :disabled="!prepare"
                               @click.stop="simulator.copyAircraftType(scope.row.type)"/>
                    <el-button icon="fa fa-fw fa-minus" type="danger"
                               :disabled="!prepare || simulator.airport.aircraft.types.length < 2"
                               @click.stop="simulator.dropAircraftType(scope.row.type)"/>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label="突发事件">
              <el-table :data="simulator.disaster.disasters">
                <el-table-column width="48px"/>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.type" :readonly="!prepare">
                      <el-option v-for="disaster in [{type: 'fire', name: '火灾'}]" :key='disaster.type'
                                 :label='disaster.name' :value='disaster.type'/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="位置">
                  <template slot-scope="scope">
                    {{scope.row.target}}
                  </template>
                </el-table-column>
                <el-table-column label="形势">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.power" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'power', 10, 200, 3000)"/>
                  </template>
                </el-table-column>
                <el-table-column label="趋势">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.growth" :readonly="!prepare"
                              @mousewheel.native="wheelChange($event, scope.row, 'growth', 5, 50, 200)"/>
                  </template>
                </el-table-column>
                <el-table-column width="160px"/>
              </el-table>
            </el-form-item>
            <el-form-item label="记录">
              <el-alert v-for="(log, index) in simulator.logs" :key="index" :title="'['+ log.time +'] ' + log.message"
                        :type="log.level"/>
            </el-form-item>
          </el-form>
        </el-aside>
        <el-main>
          <div id="chartFirePower" style="width: 1000px; height: 320px"></div>
          <div id="chartFireGrowth" style="width: 1000px; height: 320px"></div>
          <div id="chartEngineState" style="width: 1000px; height: 320px"></div>
          <div id="chartEngineCapacity" style="width: 1000px; height: 320px"></div>
          <div id="chartAircraftDurability" style="width: 1000px; height: 320px"></div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import simulator from './model/simulator'

  let STATE = {PAUSE: 0, PLAY: 1};

  export default {
    name: 'app',
    components: {},
    data() {
      document.timer = undefined;
      return {
        timer: undefined,
        delay: 500,
        forward: false,
        automate: false,
        simulator
      }
    },
    computed: {
      prepare() {
        return simulator.meta.elapse === 0 && simulator.meta.state === simulator.STATE.PAUSE;
      },
      STATE() {
        return STATE
      },
      cruiseProgress() {
        return function (engine) {
          let progress = simulator.map.distance(engine.cruise.src, engine) / simulator.map.distance(engine.cruise.src, engine.cruise.dst);
          return Math.floor(Number(String(progress).substring(0, 4)) * 100);
        }
      },
      typedEngines() {
        return function (type) {
          return simulator.station.engine.engines
            .filter(instance => instance.type === type)
            .filter(instance => Boolean(instance.cruise.dst))
        }
      },
      typedAircrafts() {
        return function (type) {
          return simulator.airport.aircraft.aircrafts.filter(instance => instance.type === type)
        };
      },
    },
    methods: {
      aircraftTypeUpdate(typeId, field) {
        let type = simulator.airport.aircraft.types.find(type => type.typeId === typeId);
        if (field === 'amount' && !isNaN(type.amount) && Number(type.amount) > 0) {
          let filtered = simulator.airport.aircraft.aircrafts.filter(aircraft => aircraft.typeId === typeId)
          for (let i = filtered.length; i < type.amount; i++) {
            simulator.buildAircraft(type.type)
          }
          for (let i = filtered.length; i > type.amount; i--) {
            simulator.dropAircraft()
          }
        } else {
          simulator.airport.aircraft.aircrafts.filter(aircraft => aircraft.typeId === typeId).forEach(aircraft => {
            aircraft[field] = type[field];
          })
        }
      },
      wheelChange(event, target, field, step, min, max, scope) {
        if (event.deltaY > 0) {
          target[field] -= step;
          if (min) {
            target[field] = Math.max(min, target[field]);
          }
        } else {
          target[field] += step;
          if (max) {
            target[field] = Math.min(max, target[field]);
          }
        }
        if (scope === 'aircraftType') {
          this.aircraftTypeUpdate(target.typeId, field)
        }
      },
      paintChart() {
        let aircrafts = simulator.airport.aircraft.aircrafts.map(aircraft => aircraft.name);
        let vue = this;
        let getOrInit = function (id) {
          return vue.$echarts.getInstanceByDom(document.getElementById(id)) || vue.$echarts.init(document.getElementById(id))
        };

        getOrInit('chartFirePower').setOption({
          title: {text: '火势变化'},
          legend: {data: aircrafts},
          grid: {left: '80'},
          xAxis: {name: '时间', type: 'category', boundaryGap: false, data: simulator.history.timeline},
          yAxis: {name: '火势', type: 'value'},
          series: simulator.history.firePower
        });

        getOrInit('chartFireGrowth').setOption({
          title: {text: '蔓延变化'},
          legend: {data: aircrafts},
          grid: {left: '80'},
          xAxis: {name: '时间', type: 'category', boundaryGap: false, data: simulator.history.timeline},
          yAxis: {name: '蔓延', type: 'value'},
          series: simulator.history.fireGrowth
        });

        getOrInit('chartEngineState').setOption({
          title: {text: '救援状态'},
          legend: {data: _.values(simulator.station.engine.stateNames)},
          grid: {left: '80'},
          xAxis: {name: '时间', type: 'category', boundaryGap: false, data: simulator.history.timeline},
          yAxis: {name: '状态', type: 'value'},
          series: simulator.history.engineState
        });

        getOrInit('chartEngineCapacity').setOption({
          title: {text: '救援储备'},
          legend: {data: simulator.station.engine.types.map(type => type.type)},
          grid: {left: '80'},
          xAxis: {name: '时间', type: 'category', boundaryGap: false, data: simulator.history.timeline},
          yAxis: {name: '状态', type: 'value'},
          series: simulator.history.engineCapacity
        });

        getOrInit('chartAircraftDurability').setOption({
          title: {text: '载体耐久'},
          legend: {data: simulator.airport.aircraft.aircrafts.map(aircraft => aircraft.name)},
          grid: {left: '80'},
          xAxis: {name: '时间', type: 'category', boundaryGap: false, data: simulator.history.timeline},
          yAxis: {name: '状态', type: 'value'},
          series: simulator.history.aircraftDurability
        });
      },
      reset() {
        this.pause();
        simulator.reset();
        let vue = this;
        let getOrInit = function (id) {
          return vue.$echarts.getInstanceByDom(document.getElementById(id)) || vue.$echarts.init(document.getElementById(id))
        };

        getOrInit('chartFirePower').clear();
        getOrInit('chartFireGrowth').clear();
        getOrInit('chartEngineState').clear();
        getOrInit('chartEngineCapacity').clear();
        getOrInit('chartAircraftDurability').clear();
      },
      cm(val) {
        let str = String(val);
        return (str.includes('.')) ? str.substr(0, str.indexOf('.') + 3) : str;
      },
      play() {
        clearInterval(this.timer);
        simulator.meta.state = simulator.STATE.PLAY;
        this.timer = setInterval(this.tick, this.delay);
      },
      pause() {
        simulator.meta.state = simulator.STATE.PAUSE;
        clearInterval(this.timer);
        this.timer = undefined;
      },
      tick() {
        simulator.tick();
        if (this.forward) {
          simulator.tick();
        }

        if (simulator.survival === 0) {
          this.pause();
          this.$alert('失败！', '', {type: 'error'});
        } else if (simulator.danger === 0) {
          this.pause();
          if (simulator.survival === simulator.airport.aircraft.aircrafts.length) {
            this.$alert('成功！', '', {type: 'success'});
          } else {
            this.$alert('再接再厉', '', {type: 'warning'});
          }
        }
        this.paintChart();
      }
    },
    mounted() {
      this.simulator.reset();

    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin: 10px;
  }

  .el-header, el-aside {
    padding: 0;
  }

  .el-form-item .el-table th {
    padding: 0;
  }

  .el-table .el-button {
    padding: 9px;
  }

  .el-table__expanded-cell[class*=cell] {
    padding: 2px 0 2px 48px;
  }

  .el-input-group__prepend {
    padding: 0 10px;
  }
</style>
